define(["require", "exports", "tslib", "mobx", "../../utils/EntityUtil", "../entity/SrCr", "../EntityBase", "../EntityValidationState", "mobx", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityUtil_1, SrCr_1, EntityBase_1, EntityValidationState_1, mobx_2, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SrCrApplication = void 0;
    class SrCrApplication extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedSrCr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SrCrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, SrCrApplication.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.SrCr = [];
        }
        onRead(entity, parent) {
            this.SrCr = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.SrCr = this.mergeArray(a.SrCr, b.SrCr, SrCr_1.SrCr);
            a.SelectedSrCr = a.SelectedSrCr && a.SrCr.find(x => x.Id == a.SelectedSrCr.Id) ? a.SelectedSrCr : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, SrCrApplication.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqString(validationState, "RefId", "Reference Id");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.SrCr) {
                for (let x of this.SrCr) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                SrCr: this.SrCr.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get ActiveCr() {
            return this.SrCr.filter(cr => cr.IsActive);
        }
        amend() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!this.SelectedSrCr) {
                    throw new Error("No selected CR");
                }
                (0, EventManager_1.notify)("Amending SR Change Request");
                const res = yield services_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.createSrCrAmendment(this.SelectedSrCr.toJson());
                (0, EventManager_1.notify)("Amendment Complete");
                (0, mobx_2.runInAction)(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    this.SelectedSrCr.merge(res.Original);
                    this.SrCr.push(new SrCr_1.SrCr(res.Amendment, this));
                    this.SelectedSrCr = this.SrCr.find(p => p.Id == res.Amendment.Id);
                    this.IncludeHistory = true;
                }));
            });
        }
    }
    exports.SrCrApplication = SrCrApplication;
    Object.defineProperty(SrCrApplication, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SrCrApplication"
    });
    Object.defineProperty(SrCrApplication, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "SRN Change Request Application"
    });
    Object.defineProperty(SrCrApplication, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId"]
    });
    Object.defineProperty(SrCrApplication, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 30
    });
    Object.defineProperty(SrCrApplication, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApplication.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApplication.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApplication.prototype, "SrCr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApplication.prototype, "SelectedSrCr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApplication.prototype, "SrCrError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SrCrApplication.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], SrCrApplication.prototype, "IncludeHistory", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], SrCrApplication.prototype, "ActiveCr", null);
});
